var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,_vm._g(_vm._b({ref:"BiuTable",tag:"component",attrs:{"columns":_vm.customColumns},on:{"setValue":function (e) { return _vm.$emit('input', e); }}},'component',_vm.attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }